import React from "react";
import _, { isEmpty, truncate } from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Map, List } from "immutable";
import DropDown, { DropDownItem } from "MODULES/shared/components/DropDown";
import { shortDate } from "LIB/formatters/date";
import { DataTable, ExternalLink } from "MODULES/shared/components";
import resourceToStateKey from "MODULES/shared/components/Notes/resourceToStateKey"; // TODO: Move this file to a better shared location!
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import Authorized from "MODULES/shared/components/Authorized";
import {
  ATTACHMENT_TYPE,
  CREATED_AT,
  CREATED_BY,
  CREATED_BY_ID,
  FILE_SIZE,
  FILE_URL,
  ID,
  NAME,
  REFERENCE_NUMBER,
  SMALL_FILE_URL,
  SMALL_VERSION_CREATED_AT
} from "APP_ROOT/constants";
import {
  CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS,
  FULL_NAME,
  PERMISSIONS
} from "MODULES/users/constants";
import ImagePortal from "MODULES/shared/components/ImagePortal/ImagePortal";
import { PHOTOS } from "MODULES/inventories/constants";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { DESCRIPTION } from "MODULES/parts/constants";
import { convertByteToMB } from "LIB/bytes";
import { getAttachments } from "../../actions/attachments";
import EditAttachment from "./EditAttachment";
import AddAttachment from "./AddAttachment";
import Delete from "./Delete";

export class Attachments extends React.Component {
  constructor() {
    super();
    this.handleDeleteAttachment = this.handleDeleteAttachment.bind(this);
  }

  state = {
    deleteOpen: false,
    openPortal: false
  };

  componentDidMount() {
    if (this.props.preloaded) return;
    this.props.dispatch(
      getAttachments(this.props.resource.get(ID), this.props.resourceType)
    );
  }

  handleDeleteAttachment() {
    this.openDeleteModal();
  }

  openDeleteModal = () => this.setState({ deleteOpen: true });

  openPortal = url => () =>
    this.setState({ openPortal: !this.state.openPortal, url });

  renderRow = attachment => {
    const url = attachment.get(FILE_URL) || attachment.get("link_url");
    const { disabled, isInventory } = this.props;
    return (
      <tr key={attachment.get(ID)}>
        <td>
          {attachment.get(SMALL_VERSION_CREATED_AT) &&
          attachment.get(ATTACHMENT_TYPE).includes("photo") ? (
            [
              <img
                alt={attachment.get(NAME)}
                src={attachment.get(SMALL_FILE_URL)}
                style={{
                  cursor: "pointer",
                  height: "50px",
                  paddingTop: "10px",
                  paddingLeft: "10px"
                }}
                onClick={this.openPortal(attachment.get(FILE_URL))}
              />,
              <span>&nbsp;&nbsp;</span>,
              <ExternalLink url={url}>
                <span className="fa fa-download" />
              </ExternalLink>
            ]
          ) : (
            <ExternalLink url={url}>{attachment.get(NAME)}</ExternalLink>
          )}
        </td>
        {this.props.referenceOptions && (
          <td>{attachment.get(REFERENCE_NUMBER)}</td>
        )}
        <td>
          {attachment.get(ATTACHMENT_TYPE) &&
            (() => {
              const typeLabel = _.get(
                Object.assign(this.props.attachmentTypes, {
                  other: {
                    label: "Other"
                  }
                }),
                `${attachment.get(ATTACHMENT_TYPE)}.label`
              );
              const description = attachment.get(DESCRIPTION) || "";
              return [typeLabel, description]
                .filter(f => !isEmpty(f))
                .join(" - ");
            })()}
        </td>
        <td>{truncate(attachment.get(DESCRIPTION), 30)}</td>
        <td>{shortDate(attachment.get(CREATED_AT))}</td>
        <td>{attachment.getIn([CREATED_BY, FULL_NAME])}</td>
        <td>{convertByteToMB(attachment.get(FILE_SIZE))}</td>
        {!isInventory && <td />}
        <td className="text-right">
          <Authorized
            authorizedIf={user =>
              user.get(ID) === attachment.get(CREATED_BY_ID) ||
              (user
                .get(PERMISSIONS)
                .includes(CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS) &&
                this.props.resourceType === resourceTypes.receivingRecord)}
          >
            {!disabled &&
              !isInventory && (
                <Delete
                  attachment={attachment}
                  resourceType={this.props.resourceType}
                />
              )}
            {isInventory && (
              <DropDown
                icon="fa fa-fw fa-ellipsis-v"
                menuClass="dropdown-menu-right"
              >
                <DropDownItem onClick={() => {}}>
                  <EditAttachment
                    id={attachment.get(ID)}
                    attachmentType={attachment.get(ATTACHMENT_TYPE)}
                    resourceType={this.props.resourceType}
                  />
                  <Delete
                    label="Delete"
                    attachment={attachment}
                    resourceType={this.props.resourceType}
                  />
                </DropDownItem>
              </DropDown>
            )}
          </Authorized>
        </td>
        <td className="text-right">
          {!disabled &&
            !isInventory && (
              <DropDown
                icon="fa fa-fw fa-ellipsis-v"
                menuClass="dropdown-menu-right"
              >
                <DropDownItem onClick={() => {}}>
                  <EditAttachment
                    id={attachment.get(ID)}
                    attachmentType={attachment.get(ATTACHMENT_TYPE)}
                    attachmentTypes={this.props.attachmentTypes}
                    resourceType={this.props.resourceType}
                  />
                </DropDownItem>
              </DropDown>
            )}
        </td>
      </tr>
    );
  };

  render() {
    const {
      attachments = List(),
      attachmentTypes,
      disabled,
      isLoading,
      multiple,
      resource,
      resourceType,
      title
    } = this.props;
    const handleKeyDown = event => {
      if (event.key === "Escape") {
        this.setState({ openPortal: false });
      }
    };

    return (
      <div tabIndex={0} onKeyDown={handleKeyDown}>
        <h2>
          {title || "Attachments"}
          {!disabled && (
            <AddAttachment
              attachmentTypes={attachmentTypes}
              multiple={multiple}
              resourceType={resourceType}
              resourceId={resource.get(ID)}
              referenceOptions={this.props.referenceOptions}
            />
          )}
        </h2>
        <ImagePortal
          setOpen={this.openPortal()}
          url={this.state.url}
          open={this.state.openPortal}
          name={PHOTOS}
        />

        <DataTable.Mini loading={isLoading}>
          <DataTable.Head>
            <th>Name</th>
            {this.props.referenceOptions && <th>Ref #</th>}
            <th>Type</th>
            <th>Desc</th>
            <th>Date Added</th>
            <th>Added By</th>
            <th>File Size</th>
            <th />
          </DataTable.Head>
          <DataTable.Body>
            {attachments.map(this.renderRow).toJS()}
          </DataTable.Body>
        </DataTable.Mini>
      </div>
    );
  }
}

Attachments.propTypes = {
  attachmentTypes: PropTypes.instanceOf(Object),
  attachments: PropTypes.instanceOf(List),
  dispatch: PropTypes.func,
  disabled: PropTypes.bool,
  isInventory: PropTypes.bool,
  isLoading: PropTypes.bool,
  multiple: PropTypes.bool,
  preloaded: PropTypes.bool,
  resourceType: PropTypes.string,
  resource: PropTypes.instanceOf(Map),
  referenceOptions: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  ...WithCurrentUser
};

export default connect((state, ownProps) => ({
  attachments: state[resourceToStateKey(ownProps.resourceType)].get(
    "attachments"
  ),
  isLoading: state[resourceToStateKey(ownProps.resourceType)].get(
    "attachmentsLoading"
  ),
  id: ownProps.resource.get(ID)
}))(withCurrentUser(Attachments));



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/Attachments.jsx